import React from 'react';
import PropTypes from 'prop-types';

import './TagList.less';

export function TagList({ className, items, itemToString, onDelete, renderItem, type }) {
  return (
    <ul className={`tag_list ${type}s ${className}`}>
      {items.map((value, index) => (
        <li key={`${index.toString()}tl`} className="list_item">
          <label htmlFor={`${type}${index}`} className={`tag ${type}`}>
            <span className="value">{renderItem(value)}</span>
            {onDelete && (
              <button type="button" className="tag_item_remove" onClick={onDelete(itemToString(value), index)}>
                {`Delete ${itemToString(value)}`}
              </button>
            )}
          </label>
        </li>
      ))}
    </ul>
  );
}

TagList.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ])),
  itemToString: PropTypes.func,
  onDelete: PropTypes.func,
  renderItem: PropTypes.func,
  type: PropTypes.string.isRequired,
};

TagList.defaultProps = {
  className: '',
  items: [],
  itemToString: (item) => (item ? `${item}` : ''),
  onDelete: null,
  renderItem: (value) => value,
};

export default TagList;
